import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentLanguage: 'it', // 'it' or 'en'
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    toggleLanguage: (state) => {
      state.currentLanguage = state.currentLanguage === 'it' ? 'en' : 'it';
    },
  },
});

export const { setLanguage, toggleLanguage } = languageSlice.actions;

export const selectLanguage = (state) => state.language.currentLanguage;

export default languageSlice.reducer;
